const USERS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  options: undefined,
}

export default USERS_INITIAL_STATE
